import { BASE_URL } from "../lib";

const token = localStorage.getItem("token");

export const Params = (params) => Object.keys(params)
    .filter(d => params[d])
    .map(d => d + '=' + params[d])
    .join('&')


const request = async (url, { headers, params, body, ...init }) => {
    try {
        if (params) {
            url += '?' + Params(params)
        }

        const headers = new Headers()
        if (token) {
            headers.append("authorization", `Token ${token}`)
        }
        if (!(body instanceof FormData)) {
            headers.append("content-type", "application/json")
            init.body = JSON.stringify(body)
        } else {
            init.body = body
        }
        init.headers = headers
        const res = await fetch(BASE_URL + url, init)
        const data = await res.json()
        if (!res.ok) {
            throw data
        }
        return data
    } catch (error) {
        throw error
    }
}

const init = { url: undefined, params: null, body: undefined }

class FetchIt {

    constructor(url) {
        this.url = url
    }

    get({ url = this.url, params } = { url: undefined, params: null }) {
        return request(url, { method: "GET", params })
    }

    post({ body, url = this.url, params } = init) {
        return request(url, { method: "POST", body, params })
    }
    put({ url = this.url, body, params } = init) {
        return request(url, { method: "PUT", body, params })
    }
    delete({ body, url = this.url, params } = init) {
        return request(url, { method: "DETELE", body, params })
    }

    patch({ body, url = this.url, params } = init) {

        return request(url, { method: "PATCH", body, params })
    }
}


export default FetchIt